
import {
    HTTP_CREATED,
    HTTP_FORBIDDEN,
    HTTP_INTERNAL_SERVER_ERROR,
    HTTP_LOCKED,
    HTTP_OK,
    HTTP_UNAUTHORIZED,
    HTTP_NOT_FOUND,
    HTTP_UNPROCESSABLE_ENTITY,
    HTTP_CONFLICT
} from '../utils/status-codes';

import {
    FORBIDDEN_ERROR,
    LOCKED_ERROR,
    SERVER_ERROR,
    UNAUTHORIZED_RESPONSE_ERROR,
    UNKNOWN_ERROR,
    PAGE_NOT_FOUND_ERROR,
    VALIDATION_ERROR
} from '../utils/error-types';
import {
    METHOD_GET
} from '../utils/http-methods';
import {store} from '../utils/store';
import {redirectOnLogOut} from "../containers/AuthWrapper/actions";



const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again later.';

function getErrorFromResponse (response, statusCode) {
    let error = {
        type: UNKNOWN_ERROR,
        message: DEFAULT_ERROR_MESSAGE
    }
    if (statusCode === HTTP_UNPROCESSABLE_ENTITY) {
        error.type = VALIDATION_ERROR;
        if (response.errors && Object.keys(response.errors).length) {
            error.validationErrors = {};
            Object.keys(response.errors).forEach(key => {
                error.validationErrors[key] = response.errors[key][0]
            });
            delete error.message;
        } else if (response.message) {
            console.warn('Got validation error without field specified.', response);
            error.message = response.message;
        }
    } else if (statusCode === HTTP_CONFLICT) {
        error.type = VALIDATION_ERROR;
        if (typeof(response.errors) === 'object' && response.errors && Object.keys(response.errors).length) {
            error.validationErrors = {};
            Object.keys(response.errors).forEach(key => {
                error.validationErrors[key] = response.errors[key]
            });
            delete error.message;
        } else {
            error.message = response.errors;
        }

    } else if (statusCode === HTTP_UNAUTHORIZED) {
        error.type = UNAUTHORIZED_RESPONSE_ERROR;
        error.message = 'Your session is expired.';
        store.dispatch(redirectOnLogOut());
    } else if (statusCode === HTTP_NOT_FOUND) {
        error.type = PAGE_NOT_FOUND_ERROR;
        error.message = `The page you're looking for can't be found.`;
    } else if (statusCode === HTTP_FORBIDDEN) {
        error.type = FORBIDDEN_ERROR;
        error.message = 'You have not sufficient privileges to view that resource.';
    } else if (statusCode === HTTP_LOCKED) {
        error.type = LOCKED_ERROR;
        error.message = 'Too many request for short period of time. Please wait for a few second and then try again.';
    } else if (statusCode >= HTTP_INTERNAL_SERVER_ERROR) { // Server Error group
        error.type = SERVER_ERROR;
        error.message = DEFAULT_ERROR_MESSAGE;
        console.error('Got server error', response, statusCode);
    } else {
        console.warn('Got wrong status code from server', response, statusCode);
    }
    return error;
}

export default function* request (options) {
    const url = process.env.REACT_APP_BASE_URL + '/api/v1' + options.route;
    delete options.route;

    options.headers = options.headers || {};
    options.headers['Content-Type'] = 'application/json';
    options.credentials = 'include';
    let statusCode;
    const returnData = {
        success: false,
        data: {},
        error: {}
    };
    return yield fetch (url, options)
        .then(response => {
            statusCode = response.status;
            if (statusCode === HTTP_OK || statusCode === HTTP_CREATED) {
                returnData.success = true;
            }
            if (statusCode >= 400 && (statusCode !== 409 && statusCode !== 422)){
                returnData.success = false;
            }
            return response.json()
                .catch(err => {
                    if (options.method === METHOD_GET) {
                        throw err;
                    } else {
                        console.warn('Invalid json response received.', err);
                        return '';
                    }
                })
        })
        .then(response => {
            if (returnData.success) {
                returnData.data = response;
            } else {
                returnData.error = getErrorFromResponse(response, statusCode);
            }
            return returnData;
        })
        .catch(error => {
            returnData.success = false;
            returnData.error.type = UNKNOWN_ERROR;
            returnData.error.message = DEFAULT_ERROR_MESSAGE;
            console.error(error);
            return returnData;
        })
}




// WEBPACK FOOTER //
// ./src/services/remote.js